module.exports = __webpack_public_path__ + "img/20220528_163138.b6f6062a.png";